module.exports = __webpack_public_path__ + "src/assets/img/bg.fd92d665.png";